import { PageController } from '@client/components/_core/layout/PageController';
import { Tabs } from '@client/components/_core/navigation/Tabs';
import { createFileRoute } from '@tanstack/react-router';
import { FileText } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/claims-products/claims')({
    staticData: {
        metadata: {
            title: 'Claims',
        },
        ui: {
            icon: FileText,
            title: 'Claims configuration',
            subtitle: 'Configure claims settings and workflows',
            useTitleForChildren: true,
            menuDescription: 'Configure claims settings and workflows',
        },
        modules: ['claim'],
        permissions: ['settings:update'],
    },

    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <ClaimsConfiguration />
        </PageController>
    );
}

function ClaimsConfiguration() {
    return (
        <Tabs
            items={[
                {
                    label: 'General',
                    to: '/console/$orgId/configuration/claims-products/claims/general',
                },
                {
                    label: 'Claim ID configuration',
                    to: '/console/$orgId/configuration/claims-products/claims/id',
                },
                {
                    label: 'Documents',
                    to: '/console/$orgId/configuration/claims-products/claims/documents',
                },
                {
                    label: 'Task lists',
                    to: '/console/$orgId/configuration/claims-products/claims/task-lists',
                },
                {
                    label: 'Customer updates',
                    to: '/console/$orgId/configuration/claims-products/claims/handling-standards',
                },
                {
                    label: 'Flags',
                    to: '/console/$orgId/configuration/claims-products/claims/claim-flags',
                },
                {
                    label: 'Claims authority',
                    to: '/console/$orgId/configuration/claims-products/claims/claims-authority',
                },
                {
                    label: 'Catastrophe events',
                    to: '/console/$orgId/configuration/claims-products/claims/catastrophe-events',
                },
            ]}
        />
    );
}
